import { util } from './util.js';

export const openAppMethod = {

    /**
     * 原生命令号拉起
     */
    openBySchemelUrl: (cmd, type, action, param) => {
        const urlParam = {
            "cmd": cmd,
            "jsonStr": param,
            "type": type,
            "action": action
        }
        // 原生命令号传参，并且 url 编码
        const schemelUrlParam = encodeURIComponent(JSON.stringify(urlParam));

        const schemelUrlAndroid = 'kugou://start.weixin?' + schemelUrlParam;
        const schemelUrlIOS = 'kugouurl://start.weixin?' + schemelUrlParam;
        let schemelUrl = "";

        if (util.getSysBowser()[0] == 1) {
            // android
            schemelUrl = schemelUrlAndroid;
        } else {
            // ios
            schemelUrl = schemelUrlIOS;
        }

        window.location.href = schemelUrl;
    },

    /**
     * 微信白名单拉起
     */
    openByWeChat: (cmd, type, action, param, callback) => {
        const urlParam = {
            "cmd": cmd,
            "jsonStr": param,
            "type": type,
            "action": action
        }

        util.initWXSign(() => {
            try {
                var weixinJson = {
                    "is_start_weixin": true,
                    "real_content": "kugou://start.weixin?" + JSON.stringify(urlParam)
                };
                window.wx.invoke('launchApplication', {
                    "appID": 'wx79f2c4418704b4f8',
                    "parameter": 'kugouurl://start.weixin?' + encodeURIComponent(JSON.stringify(urlParam)),
                    "extInfo": 'kugouURL://start.fanxing?' + encodeURIComponent(JSON.stringify(weixinJson)),
                }, function (res) {
                    if (res.err_msg === "launchApplication:ok") {
                        // 拉起成功
                        callback && callback(true);
                    } else if (res.err_msg === "launchApplication:fail") {
                        // 拉起失败
                        callback && callback(false);
                    } else {
                        // 拉起失败
                        callback && callback(false);
                    }
                })
            } catch (error) {
                callback && callback(false);
            }
        });
    },

    /**
     * 微信通用链拉起
     */
    openByWeChatWithUrl: (cmd, type, action, param) => {
        const urlParamObj = {
            cmd: cmd,
            jsonStr: param,
            type: type,
            action: action
        };
        const urlParam = encodeURIComponent(JSON.stringify(urlParamObj));
        const url = "https://m3ws.kugou.com/share/weixin.html?data=" + urlParam + "&ackey=CK1350585625600";
        window.location.href = url;
    },

    /**
     * Universal Links 拉起 (https://mo.kugou.com/universal/)
     */
    openByUniversalLinks: (cmd, type, action, param) => {
        const urlParam = encodeURIComponent(JSON.stringify(param));
        let url = "https://mo.kugou.com/universal/?Type=" + type + "&Action=" + action + "&Json=" + urlParam + "&channel=yykfzj";
        url += "&rt=1&ra="+encodeURIComponent("pt=624347&ct=yykfzj&mt=8")
        window.location.href = url;
    },

    /**
     * android 应用宝拉起
     */
    openByAndroidAppStore: (cmd, type, action, param,ckey) => {
        const urlParam = {
            "cmd": cmd,
            "jsonStr": param,
            "type": type,
            "action": action
        }
        // 原生命令号传参，并且 url 编码
        const schemelUrlParam = encodeURIComponent(JSON.stringify(urlParam));
        const schemelUrlAndroid = 'kugou://start.weixin?' + schemelUrlParam;
        const kugouUrlOnAndroidAppStore = "https://a.app.qq.com/o/simple.jsp?pkgname=com.kugou.android&ckey="+(ckey?ckey:"CK1350585625600");
        window.location.href = kugouUrlOnAndroidAppStore + "&android_schema=" + schemelUrlAndroid;
    },

    /**
     * ios appstore 拉起
     */
    openByIOSAppStore: (cmd, type, action, param) => {
        const urlParam = {
            "cmd": cmd,
            "jsonStr": param,
            "type": type,
            "action": action
        }
        // 原生命令号传参，并且 url 编码
        const schemelUrlParam = encodeURIComponent(JSON.stringify(urlParam));
        const schemelUrlIOS = 'kugouurl://start.weixin?' + schemelUrlParam;

        const kugouUrlOnIOSAppStore = "https://itunes.apple.com/app/apple-store/id472208016?pt=624347&ct=yykfzj&mt=8";

        window.location.href = kugouUrlOnIOSAppStore + "&android_schema=" + schemelUrlIOS + "&schema_version=7950";
    },

    /**
     * 弹窗提示浏览器打开拉起
     */
    openByTips: () => {
        // 蒙层 div
        let _div = document.getElementById('pop_mask2');
        if (!!_div) {
            _div.style.display = 'block';
        } else {
            _div = document.createElement('div');
            _div.classList.add('pop_mask2');
            _div.setAttribute("style", "width: 100%; height: 100%; z-index: 9999; position: fixed; top: 0; left: 0; display: none;")
            _div.setAttribute('id', 'pop_mask2');
            document.body.appendChild(_div);
            // 提示图片
            _div.innerHTML = '<img style="width: 100%; height: 100%; display: block;" src="http://webimg.bssdl.kugou.com/acf6178e56ecd99bee6b013d39061689.png"/>';
        }

        // 点击关闭
        _div.addEventListener('click', function () {
            this.style.display = 'none';
        }, false);

        _div.style.display = 'block';
    },
}